<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { MyQuiztersStartPage, useQuizterStore } from '@ilteducation/games';
import { useLocale, useLocalisation } from '@/plugins/translation';

// Load Quizter translations from the Quizter Lokalise project
const { includeAdditionalProject } = useLocalisation();
includeAdditionalProject('Quizter', false);

const { t } = useLocale();
const router = useRouter();
const quizterStore = useQuizterStore();

const gamesPath = router.resolve({ name: 'Games' }).href;
const absoluteGamesUrl = `${window.location.origin}${gamesPath}`;

const returnParams = computed(() => ({
  url: window.location.href,
  text: t('quiz.back'),
}));

const returnParamsPlayer = computed(() => ({
  url: absoluteGamesUrl,
  text: t('quizter.back_to_games'),
}));

const goBack = () => {
  router.push({ name: 'QuizterHomePage' });
};

const goToEdit = (activityId: string) => {
  router.push({ name: 'QuizterEditPage', params: { activityId } });
};

const handleStart = async (resourceIds: string[], activityId: string) => {
  if (resourceIds.length === 0 || !activityId) {
    return;
  }
  await quizterStore.createGame(
    resourceIds,
    false,
    activityId,
    undefined,
    returnParams.value,
    returnParamsPlayer.value,
  );
  const gameId = quizterStore.gameId;
  if (gameId) {
    router.push({ name: 'HostQuizter', params: { gameId } });
  }
};
</script>

<template>
  <MyQuiztersStartPage @start="handleStart" @edit="goToEdit" @back="goBack" />
</template>

<style scoped lang="scss"></style>
